query GetOrganizations {
  availableOrganizations {
    id
    name
    displayName
    isCurrent
  }
}
